import { useState, useEffect, useRef } from "react";
import { api } from "@/lib/api";

// UNIFIED.6 — Flight Session archive Backend EXACTE, corrélée au lease (droneId + sessionId).
// Uniquement GET /flight-sessions/<drone>/<SID> : aucune recherche de session courante, aucun tri.
// 404 => archive pas encore créée (waiting_archive, PAS une erreur). Polling borné read-only.
// Toute réponse tardive d'une paire (droneId, sessionId) précédente est ignorée (anti-mélange de sessions).
const POLL_MS = 7000;

export function useCurrentFlightSession(droneId, sessionId, enabled = true) {
  const [state, setState] = useState("idle");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const reqRef = useRef(0);

  useEffect(() => {
    if (!enabled || !droneId || !sessionId) {
      setState("idle");
      setData(null);
      setError(null);
      return;
    }
    const myReq = ++reqRef.current;
    let cancelled = false;
    let timer = null;
    const fresh = () => !cancelled && myReq === reqRef.current;

    const poll = async () => {
      try {
        const { data: resp } = await api.get(
          `/flight-sessions/${encodeURIComponent(droneId)}/${encodeURIComponent(sessionId)}`
        );
        if (!fresh()) return;
        setData(resp);
        setError(null);
        setState("available");
      } catch (e) {
        if (!fresh()) return;
        if (e?.response?.status === 404) {
          setData(null);
          setError(null);
          setState("waiting_archive");
        } else {
          setError(e);
          setState("error");
        }
      }
      if (fresh()) timer = setTimeout(poll, POLL_MS);
    };

    setState("waiting_archive");
    setData(null);
    setError(null);
    poll();

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [droneId, sessionId, enabled]);

  return { state, data, error };
}
